// src/pages/PrimaryClass.jsx
import React from "react";
import { useNavigate, useParams } from "react-router-dom";

export default function PrimaryClass() {
  const { classId } = useParams();
  const navigate = useNavigate();

  const subjects = [
    { id: "english", name: "English" },
    { id: "math", name: "Mathematics" },
    { id: "science", name: "Science" },
  ];

  return (
    <div className="min-h-screen p-6 bg-blue-50">
      <h1 className="text-3xl font-bold mb-6 text-center">
        {classId.toUpperCase()}
      </h1>

      <div className="grid md:grid-cols-3 gap-6 max-w-4xl mx-auto">
        {subjects.map((sub) => (
          <div
            key={sub.id}
            onClick={() =>
              navigate(`/primary/${classId}/${sub.id}`)
            }
            className="bg-white p-6 rounded-xl shadow cursor-pointer hover:shadow-lg transition"
          >
            <h2 className="text-xl font-semibold text-center">
              {sub.name}
            </h2>
          </div>
        ))}
      </div>
    </div>
  );
}
